import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../chat-menu-dialog.action';
import { ChatMenuDialogState } from '../chat-menu-dialog.state';

import { MinMax } from './min-max.action';

export function minMaxReducer(
    state: ChatMenuDialogState,
    action: PayloadAction<ActionType.TC__CM__MIN_MAX, MinMax>,
): ChatMenuDialogState {
    try {
        return {
            ...state,
            minimized: action.payload.minimized,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
